module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-maedori2-fd6c5fdb8e1a152870ff45b3239896b0.webp";